// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// icons
import LinkIconOrigin from '@mui/icons-material/Link'
import CopyIconOrigin from '@mui/icons-material/ContentCopy'
// utils
import { size } from 'polished'

export const LinkIcon = styled(LinkIconOrigin)<{ active?: boolean }>`
  ${size('18px')};

  path {
    fill: ${({ active }) => (active ? colors.blue500 : colors.gray300)};
  }
`

export const CopyIcon = styled(CopyIconOrigin)<{ active?: boolean }>`
  ${size('14px')};

  path {
    fill: ${({ active }) => (active ? colors.blue500 : colors.gray300)};
  }
`

export const ButtonsWrapper = styled('div')`
  background-color: ${colors.white100};
  border-radius: 25px;
  border: 1px solid ${colors.blue500};
  display: flex;
  height: 24px;
  justify-content: space-around;
  width: fit-content;
  min-width: 38px;
  padding: 0 2px;

  > div:not(:last-child) {
    border-right: 1px solid ${colors.blue500};
  }

  > div {
    padding: 0 2px;
    min-width: 24px;
  }
`

export const Button = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`
